/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getLiveStream, getLiveStreamList } from "./requestCall";
import Markdown from "markdown-to-jsx";
import { useState } from "react";
import { PlayButton } from "../../shared/assets/icons/PlayButton.jsx";
import { v4 } from "uuid";

const liveStreamWrapper = (matches) => css`
  padding: 0 ${matches ? 0 : "calc(3% + 32px)"};
  background: #121212;
  padding-top: 20px;
`;
const cardWrapper = css`
  background: #121212;
  border: none;
  box-shadow: none;
  .MuiCardActionArea-root {
    position: relative;
    .MuiSvgIcon-root {
      position: absolute;
      top: calc(50% - 31px);
      left: calc(50% - 31px);
      height: 62px;
      width: 62px;
      color: white;
    }
  }
  .MuiCardContent-root {
    background: #121212;
    .MuiTypography-root {
      color: white;
    }
  }
  video {
    width: 100%;
  }
`;
const contentWrapper = css`
  display: flex;
  flex-direction: column;
`;
const bannerTitleWrapper = (matches) => css`
  color: white;
  margin: 20px 0;
  padding-left: ${matches ? "16px" : 0};
`;
const bannerWrapper = (order) => css`
  order: ${order};
`;
const loadMore = css`
  display: flex;
  justify-content: center;
  .MuiButton-root {
    background: #121212;
    color: #2699fb;
    box-shadow: none;
  }
  .MuiButton-root:hover {
    background: #121212;
  }
`;
const subBannerWrapper = (matches, order) => css`
  display: flex;
  order: ${order};
  justify-content: space-between;
  flex-wrap: wrap;
  .MuiBox-root {
    display: flex;
    flex-direction: ${matches ? "column" : "row"};
    justify-content: space-between;
  }
`;
const streamListWrapper = (matches, order) => css`
  display: flex;
  flex-wrap: wrap;
  order: ${order};
  flex-direction: ${matches ? "column" : "row"};
  .MuiPaper-root:nth-of-type(3n + 2) {
    margin: 0 ${matches ? 0 : "2%"};
  }
`;
const descriptionWrapper = css`
  font-size: 14px;
  line-height: 35px;
`;
const bannerVideoWrapper = css`
  svg {
    pointer-events: none;
  }
`;
const BannerVideo = ({ videoSrc, showVideoPlayIcon }) => {
  const [play, setPlay] = useState(true);
  const handleClick = () => {
    const video = document.getElementById("bannerVideo");
    setPlay(!video.paused);
  };
  const videoNode = document.getElementById("bannerVideo");

  videoNode?.addEventListener("play", function () {
    setPlay(false);
  });
  videoNode?.addEventListener("pause", function () {
    setPlay(true);
  });
  return (
    <Box css={bannerVideoWrapper}>
      <video
        id="bannerVideo"
        controls="controls"
        src={videoSrc}
        onClick={handleClick}
      />
      {showVideoPlayIcon && play && <PlayButton />}
    </Box>
  );
};
const cardTemplate = (
  src,
  showVideoPlayIcon,
  head,
  description,
  width,
  id,
  isBanner,
  videoSrc,
  isExternalLink
) => {
  const link = isBanner ? id : `/news/live-stream/${id}`;
  return (
    <Card sx={{ width: width }} css={cardWrapper} key={v4()}>
      <CardActionArea>
        {videoSrc ? (
          <BannerVideo
            videoSrc={videoSrc}
            showVideoPlayIcon={showVideoPlayIcon}
          />
        ) : (
          src &&
          (isExternalLink ? (
            <a href={link} target="_blank" rel="noreferrer">
              <CardMedia
                component="img"
                image={`${process.env.REACT_APP_BASEURL}${src}`}
                alt={head}
              />
              {showVideoPlayIcon && <PlayButton />}
            </a>
          ) : (
            <Link to={link}>
              <CardMedia
                component="img"
                image={`${process.env.REACT_APP_BASEURL}${src}`}
                alt={head}
              />
              {showVideoPlayIcon && <PlayButton />}
            </Link>
          ))
        )}
      </CardActionArea>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {head}
        </Typography>
        <Typography
          css={descriptionWrapper}
          variant="body2"
          color="text.secondary"
        >
          <Markdown>{description || ""}</Markdown>
        </Typography>
      </CardContent>
    </Card>
  );
};
const LiveStream = () => {
  const [banner, setBanner] = useState([]);
  const [subBanner, setSubBanner] = useState();
  const [streamList, setStreamList] = useState([]);
  const [currentDisplayedStreamList, setCurrentDisplayedStreamList] = useState(
    []
  );
  const matches = useMediaQuery("(max-width: 415px)");
  const [streamListConfig, setStreamListConfig] = useState([]);
  const [order, setOrder] = useState({ banner: 0, subBanner: 1, list: 2 });
  useEffect(() => {
    getLiveStream().then((res) => {
      document.title = res?.data?.data?.attributes?.title;
      setBanner(
        res?.data?.data?.attributes?.body?.filter(
          (item) =>
            item.__component === "components.banner-image-with-text-tiles"
        )
      );
      setSubBanner(
        res?.data?.data?.attributes?.body?.filter(
          (item) => item.__component === "components.list"
        )
      );
      const liveStreamOrder = { banner: 0, subBanner: 1, list: 2 };
      res?.data?.data?.attributes?.body.forEach((item, index) => {
        if (item.__component === "components.banner-image-with-text-tiles") {
          liveStreamOrder.banner = index + 2;
        }
        if (item.__component === "components.list") {
          liveStreamOrder.subBanner = index + 2;
        }
        if (item.__component === "components.live-stream-list") {
          liveStreamOrder.list = index + 2;
        }
      });
      setOrder(liveStreamOrder);
      const streamListConfigInfo = res?.data?.data?.attributes?.body?.filter(
        (item) => item.__component === "components.live-stream-list"
      );
      setStreamListConfig(streamListConfigInfo);
      getLiveStreamList().then((listRes) => {
        setStreamList(listRes?.data?.data);
        setCurrentDisplayedStreamList(
          listRes?.data?.data.length <
            streamListConfigInfo[0]?.numberOfVisibleVideos
            ? listRes?.data?.data
            : listRes?.data?.data.slice(
                0,
                streamListConfigInfo[0]?.numberOfVisibleVideos
              )
        );
      });
    });
  }, []);
  const handleLoadMore = () => {
    setCurrentDisplayedStreamList(
      streamList.slice(
        0,
        currentDisplayedStreamList.length +
          streamListConfig[0]?.numberOfVideosSetToLoadNext
      )
    );
  };

  return (
    <Box css={() => liveStreamWrapper(matches)}>
      <Typography variant="h5" css={() => bannerTitleWrapper(matches)}>
        {banner[0]?.title}
      </Typography>
      <div css={contentWrapper}>
        <Box css={() => bannerWrapper(order.banner)}>
          {banner?.map((item) =>
            cardTemplate(
              item.bannerImage?.data?.attributes?.url,
              item.showVideoPlayIcon,
              item.textTiles[0]?.heading,
              item.textTiles[0]?.description,
              "100%",
              item?.link,
              true,
              item.bannerVideoSource,
              item.isExternalLink
            )
          )}
        </Box>
        <Box css={() => subBannerWrapper(matches, order.subBanner)}>
          {subBanner?.map((sub) => {
            return (
              <Box key={sub.id}>
                {sub?.ctaList?.map((item) =>
                  cardTemplate(
                    item?.image?.data?.attributes?.url,
                    item?.showVideoPlayIcon,
                    item?.Title,
                    item?.description,
                    matches ? "100%" : "49%",
                    item?.ctaLink,
                    true,
                    undefined,
                    item.isExternalLink
                  )
                )}
              </Box>
            );
          })}
        </Box>
        <Box css={() => streamListWrapper(matches, order.list)}>
          {currentDisplayedStreamList?.map((item) =>
            cardTemplate(
              item.attributes?.thumbnailImage?.data?.attributes?.url,
              item.showVideoPlayIcon,
              item.attributes?.title,
              item.attributes?.description,
              matches ? "100%" : "32%",
              item.attributes?.slug,
              false,
              undefined,
              item.isExternalLink
            )
          )}
        </Box>
      </div>
      {!(currentDisplayedStreamList?.length === streamList?.length) && (
        <Box css={loadMore}>
          <Button
            onClick={handleLoadMore}
            variant="contained"
            endIcon={<KeyboardArrowDownIcon />}
          >
            {streamListConfig[0]?.loadMore}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default LiveStream;
